import { render } from "./groupModal.vue?vue&type=template&id=0f4bb308&ts=true"
import script from "./groupModal.vue?vue&type=script&lang=ts"
export * from "./groupModal.vue?vue&type=script&lang=ts"

import "./groupModal.vue?vue&type=style&index=0&id=0f4bb308&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__